var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_23920",
    "data-name": "Group 23920",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 211.125,
    height: 40,
    viewBox: "0 0 211.125 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63743",
    "data-name": "Rectangle 63743",
    width: 211.125,
    height: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63730",
    "data-name": "Rectangle 63730",
    width: 211.12,
    height: 40,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29885",
    "data-name": "Path 29885",
    d: "M3.54,3.543h0A6.972,6.972,0,0,0,3.534,13.4a4.328,4.328,0,0,0,.4.36,6.9,6.9,0,0,0,2.458,1.37c2.693,1.029,8.938,4.272,11.695,7.03,2.7,2.7,6.015,9.114,7.018,11.74.05.128.1.24.153.36a6.973,6.973,0,0,0,.859,1.585c.086.122.166.232.239.327a4.542,4.542,0,0,0,.467.519l.01.012A6.976,6.976,0,0,0,36.7,26.834l-.011-.011a5.61,5.61,0,0,0-1.037-.849c-.071-.048-.145-.092-.22-.136-.119-.075-.241-.148-.378-.224l-.083-.043a9.686,9.686,0,0,0-1.045-.5c-2.586-1.04-8.907-4.425-11.619-7.136-2.73-2.729-6.047-8.981-7.095-11.576A8.006,8.006,0,0,0,13.4,3.534a6.976,6.976,0,0,0-9.855.009",
    transform: "translate(-1.499 -1.5)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.018,
    y1: 1.018,
    x2: 0.006,
    y2: 1.018,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0197e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#017dd7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63733",
    "data-name": "Rectangle 63733",
    width: 23.134,
    height: 18.381,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63732",
    "data-name": "Rectangle 63732",
    width: 23.128,
    height: 18.373,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63735",
    "data-name": "Rectangle 63735",
    width: 3.039,
    height: 2.692,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63734",
    "data-name": "Rectangle 63734",
    width: 3.039,
    height: 2.657,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29891",
    "data-name": "Path 29891",
    d: "M3.4,30.647A5.993,5.993,0,1,0,7.636,28.89,5.994,5.994,0,0,0,3.4,30.647",
    transform: "translate(-1.643 -28.89)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.07,
    y1: 1.068,
    x2: 0,
    y2: 1.068,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63739",
    "data-name": "Rectangle 63739",
    width: 11.39,
    height: 8.758,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63738",
    "data-name": "Rectangle 63738",
    width: 11.377,
    height: 8.739,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63741",
    "data-name": "Rectangle 63741",
    width: 2.207,
    height: 1.974,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63740",
    "data-name": "Rectangle 63740",
    width: 2.205,
    height: 1.928,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23882",
    "data-name": "Group 23882",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29874",
    "data-name": "Path 29874",
    d: "M58.076,30.874V10.948h2.533L74.554,28.826V10.948h1.927V30.874H73.826L60,13V30.874Z",
    transform: "translate(-4.661 -0.879)",
    fill: "#777677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29875",
    "data-name": "Path 29875",
    d: "M82.913,30.874V10.948H98.232v1.859H84.907v6.979h12.3v1.873h-12.3V29H98.232v1.873Z",
    transform: "translate(-6.654 -0.879)",
    fill: "#777677"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23853",
    "data-name": "Group 23853",
    transform: "translate(0.005 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23852",
    "data-name": "Group 23852",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29876",
    "data-name": "Path 29876",
    d: "M103.253,10.948h2.023V23.181q0,3.26,1.6,4.775t5.039,1.517q3.449,0,5.066-1.523a6.274,6.274,0,0,0,1.617-4.769V10.948h2.007V23.707a7.214,7.214,0,0,1-2.243,5.7q-2.242,1.989-6.447,1.988-4.244,0-6.454-1.98a7.385,7.385,0,0,1-2.207-5.806Z",
    transform: "translate(-8.29 -0.879)",
    fill: "#777677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29877",
    "data-name": "Path 29877",
    d: "M126.946,30.873V10.946H136.5a8.848,8.848,0,0,1,5.348,1.347,4.707,4.707,0,0,1,1.792,4.016,5.452,5.452,0,0,1-.828,3.173,4.946,4.946,0,0,1-2.62,1.784,3.48,3.48,0,0,1,2.177,1.012,5.375,5.375,0,0,1,.882,2.775q.092.768.189,2.129a8.251,8.251,0,0,0,.781,3.692H141.9a13.177,13.177,0,0,1-.5-3.2q-.121-2.054-.189-2.621a2.89,2.89,0,0,0-1.072-2.109,4.964,4.964,0,0,0-2.823-.625h-8.38v8.554ZM136.027,12.8H128.94v7.639h7.329a7.18,7.18,0,0,0,4.109-.9,3.369,3.369,0,0,0,1.254-2.937,3.309,3.309,0,0,0-1.254-2.931,8.014,8.014,0,0,0-4.351-.868",
    transform: "translate(-10.192 -0.877)",
    fill: "#777677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29878",
    "data-name": "Path 29878",
    d: "M169.246,20.87a10.377,10.377,0,0,1-2.8,7.68,11.924,11.924,0,0,1-15.36,0,10.4,10.4,0,0,1-2.789-7.68,10.425,10.425,0,0,1,2.789-7.693,11.924,11.924,0,0,1,15.36,0,10.392,10.392,0,0,1,2.8,7.693m-10.485,8.554a8.3,8.3,0,0,0,6.191-2.277,8.56,8.56,0,0,0,2.243-6.278,8.551,8.551,0,0,0-2.243-6.285,9.592,9.592,0,0,0-12.395,0,8.554,8.554,0,0,0-2.244,6.285,8.556,8.556,0,0,0,2.244,6.278,8.309,8.309,0,0,0,6.2,2.277",
    transform: "translate(-11.905 -0.831)",
    fill: "#777677"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29879",
    "data-name": "Path 29879",
    d: "M180.021,30.874V12.78h-7.693V10.948h17.383V12.78h-7.693V30.874Z",
    transform: "translate(-13.834 -0.879)",
    fill: "#017dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29880",
    "data-name": "Path 29880",
    d: "M188.889,30.874l9.188-19.926h2.29l9.081,19.926h-2.007l-2.79-6.157h-10.9l-2.816,6.157Zm5.739-8.084h9.135L199.2,12.605Z",
    transform: "translate(-15.163 -0.879)",
    fill: "#017dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29881",
    "data-name": "Path 29881",
    d: "M213.769,30.874V10.948h1.994V29h12.516v1.873Z",
    transform: "translate(-17.159 -0.879)",
    fill: "#017dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29882",
    "data-name": "Path 29882",
    d: "M38.834,14.387a1.345,1.345,0,0,1-.644-.164l-3-1.621-2.978,1.62a1.356,1.356,0,0,1-1.977-1.435l.613-3.357L28.381,7.1a1.354,1.354,0,0,1,.755-2.322l3.383-.454L33.98,1.257a1.356,1.356,0,0,1,2.442,0L37.9,4.334l3.362.441A1.354,1.354,0,0,1,42.018,7.1l-2.47,2.356.621,3.334a1.358,1.358,0,0,1-1.095,1.578,1.317,1.317,0,0,1-.24.022M35.8,1.557l-.623.3L33.743,4.931a1.354,1.354,0,0,1-1.037.755l-3.385.454L31.8,8.454a1.357,1.357,0,0,1,.4,1.222l-.613,3.358,2.966-1.646a1.349,1.349,0,0,1,1.288,0l3,1.62L38.2,9.677a1.363,1.363,0,0,1,.4-1.222L41.062,6.1l-3.367-.411a1.353,1.353,0,0,1-1.04-.754L35.176,1.855Z",
    transform: "translate(-2.249 -0.039)",
    fill: "#017dd7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29883",
    "data-name": "Path 29883",
    d: "M31.7,39.369a7.614,7.614,0,0,1-5.4-2.229,3.751,3.751,0,0,1-.552-.606c-.084-.1-.171-.225-.266-.361a7.531,7.531,0,0,1-.934-1.734l-.028-.061c-.041-.092-.083-.191-.123-.3-.971-2.547-4.276-8.913-6.858-11.5C14.884,19.928,8.671,16.7,6.085,15.71a7.486,7.486,0,0,1-2.667-1.493,4.469,4.469,0,0,1-.453-.413A7.665,7.665,0,0,1,13.823,2.983L13.8,3a9.335,9.335,0,0,1,1.988,3.041c1.036,2.575,4.331,8.738,6.94,11.346,2.636,2.635,8.816,5.947,11.39,6.984a10.41,10.41,0,0,1,1.117.53l.086.045c.151.084.284.164.411.243s.184.111.241.151a6.11,6.11,0,0,1,1.17.967A7.663,7.663,0,0,1,31.7,39.369",
    transform: "translate(-0.063 -0.059)",
    fill: "#199894"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29884",
    "data-name": "Path 29884",
    d: "M8.353,1.38a6.951,6.951,0,0,1,4.923,2.034,8,8,0,0,1,1.812,2.828c1.044,2.594,4.362,8.845,7.091,11.575,2.715,2.711,9.037,6.1,11.624,7.136a9.756,9.756,0,0,1,1.044.5l.083.044c.137.075.26.149.379.223l.22.136a5.567,5.567,0,0,1,1.037.849l.012.011a6.975,6.975,0,1,1-9.865,9.864l-.011-.012a4.375,4.375,0,0,1-.467-.518c-.075-.092-.155-.2-.24-.327a6.893,6.893,0,0,1-.86-1.586c-.051-.119-.1-.23-.152-.359-1-2.626-4.317-9.039-7.018-11.74-2.759-2.759-9-6-11.7-7.029a6.924,6.924,0,0,1-2.458-1.37,4.326,4.326,0,0,1-.4-.36,6.974,6.974,0,0,1,4.94-11.9m0-1.38h0A8.354,8.354,0,0,0,2.39,14.2a4.27,4.27,0,0,0,.546.5,8.221,8.221,0,0,0,2.877,1.606c2.561.985,8.6,4.128,11.175,6.7,2.519,2.519,5.75,8.757,6.7,11.256.043.11.086.211.13.31l.034.078a8.343,8.343,0,0,0,1.019,1.873c.092.129.184.259.276.373a6.124,6.124,0,0,0,.6.659A8.355,8.355,0,0,0,37.563,25.748a6.224,6.224,0,0,0-1.269-1.042c-.062-.042-.132-.085-.2-.127l-.058-.035c-.132-.083-.276-.167-.433-.256l-.119-.063a10.944,10.944,0,0,0-1.164-.552c-2.459-.991-8.626-4.3-11.16-6.833S17.388,8.254,16.376,5.727a9.419,9.419,0,0,0-2.143-3.311A8.3,8.3,0,0,0,8.353,0",
    transform: "translate(-0.005 0)",
    fill: "#0f3b56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23855",
    "data-name": "Group 23855",
    transform: "translate(1.379 1.38)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23854",
    "data-name": "Group 23854",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63731",
    "data-name": "Rectangle 63731",
    width: 38.603,
    height: 37.923,
    transform: "translate(-0.681 0)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23867",
    "data-name": "Group 23867",
    transform: "translate(0.005 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23866",
    "data-name": "Group 23866",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23860",
    "data-name": "Group 23860",
    transform: "translate(1.381 1.381)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23859",
    "data-name": "Group 23859"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23858",
    "data-name": "Group 23858",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23857",
    "data-name": "Group 23857",
    transform: "translate(0.006 0.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23856",
    "data-name": "Group 23856",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29886",
    "data-name": "Path 29886",
    d: "M3.923,5.8A6.339,6.339,0,0,1,7.8,3.115a6.069,6.069,0,0,1,5.386,1.924,16.423,16.423,0,0,1,1.6,2.816c1.127,2.25,4.04,7.874,6.688,10.122.137.117,3.209,1.931,3.161,1.9-.248-.166-.447-.4-.709-.552a7.451,7.451,0,0,1-1.2-.98,22.388,22.388,0,0,1-3.108-3.909,53.766,53.766,0,0,1-4.406-8.067,8.662,8.662,0,0,0-1.815-2.831,6.971,6.971,0,0,0-10.016,9.7A7.24,7.24,0,0,1,3.923,5.8",
    transform: "translate(-1.512 -1.509)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29887",
    "data-name": "Path 29887",
    d: "M37.563,36.1a6.34,6.34,0,0,1-3.876,2.685A6.071,6.071,0,0,1,28.3,36.858a16.423,16.423,0,0,1-1.6-2.816c-1.127-2.25-3.5-7.994-6.149-10.241-.137-.117-3.662-1.982-3.613-1.954,4.638,2.759,8.288,11.084,9.332,13.679a8,8,0,0,0,1.815,2.828,6.971,6.971,0,0,0,10.016-9.7,7.24,7.24,0,0,1-.533,7.439",
    transform: "translate(-1.363 -1.753)",
    fill: "#04639e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23865",
    "data-name": "Group 23865",
    transform: "translate(7.057 4.112)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23864",
    "data-name": "Group 23864"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23863",
    "data-name": "Group 23863",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23862",
    "data-name": "Group 23862",
    transform: "translate(0 0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23861",
    "data-name": "Group 23861",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29888",
    "data-name": "Path 29888",
    d: "M10.686,5.462A1.436,1.436,0,0,1,9.5,7.1,1.434,1.434,0,0,1,7.71,6.171,1.436,1.436,0,0,1,8.892,4.536a1.436,1.436,0,0,1,1.794.926",
    transform: "translate(-7.678 -4.488)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_29889",
    "data-name": "Path 29889",
    d: "M7.577,41.515A6.686,6.686,0,1,1,12.3,39.557a6.686,6.686,0,0,1-4.728,1.958",
    transform: "translate(-0.076 -2.259)",
    fill: "#199894"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29890",
    "data-name": "Path 29890",
    d: "M7.515,28.77a6,6,0,1,1-4.24,1.757,6,6,0,0,1,4.24-1.757m0-1.38a7.378,7.378,0,1,0,5.215,2.161A7.379,7.379,0,0,0,7.515,27.39",
    transform: "translate(-0.015 -2.198)",
    fill: "#0f3b56"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23869",
    "data-name": "Group 23869",
    transform: "translate(1.511 26.572)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23868",
    "data-name": "Group 23868",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_63737",
    "data-name": "Rectangle 63737",
    width: 13.16,
    height: 12.574,
    transform: "translate(-0.586 0)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23881",
    "data-name": "Group 23881",
    transform: "translate(0.005 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23880",
    "data-name": "Group 23880",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29892",
    "data-name": "Path 29892",
    d: "M13.055,32.416A6.4,6.4,0,0,1,2.791,38.563a5.994,5.994,0,0,0,10.264-6.151",
    transform: "translate(-0.229 -2.601)",
    fill: "#04639e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23874",
    "data-name": "Group 23874",
    transform: "translate(1.493 26.554)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23873",
    "data-name": "Group 23873"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23872",
    "data-name": "Group 23872",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23871",
    "data-name": "Group 23871",
    transform: "translate(0.013 0.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23870",
    "data-name": "Group 23870",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29893",
    "data-name": "Path 29893",
    d: "M4.033,32.1a6.255,6.255,0,0,1,8.843,0c.05.051.092.106.142.157a5.994,5.994,0,1,0-10.79,5.224c.024.051.05.1.075.151A6.244,6.244,0,0,1,4.033,32.1",
    transform: "translate(-1.641 -28.888)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_23879",
    "data-name": "Group 23879",
    transform: "translate(7.69 29.02)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23878",
    "data-name": "Group 23878"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23877",
    "data-name": "Group 23877",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23876",
    "data-name": "Group 23876",
    transform: "translate(0.003 0.012)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23875",
    "data-name": "Group 23875",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29894",
    "data-name": "Path 29894",
    d: "M10.551,32.271a1.04,1.04,0,0,1-.862,1.186.965.965,0,0,1-.717-1.792.982.982,0,0,1,.276-.065,1.04,1.04,0,0,1,1.3.671",
    transform: "translate(-8.369 -31.564)",
    fill: "#fff"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9c2873bf85fe56a41cb01ac1c1514b3e.svg";
export { ForwardRef as ReactComponent };